import axios from 'axios'
import { USE_MOCK_DATABASE } from '../../config/mockdb'
import { MockPosts } from '../mock'
import { PostDTO } from '../dto'
import { APIurl } from '..'

export async function GetPostById(id: string): Promise<PostDTO | null> {
    if (USE_MOCK_DATABASE) {
        return MockPosts.filter((post) => post._id === id)[0] ?? null
    }

    return (await axios.get<PostDTO>(APIurl + `/posts/${encodeURIComponent(id)}`)).data
}
